// extracted by mini-css-extract-plugin
module.exports = {"faq":"style-module--faq--2SKcq","title":"style-module--title--3lEGG"};